// extracted by mini-css-extract-plugin
export default {"subtext":"Subtext_subtext__J8fm8"};